/**
 * Groups pasted CMS markup (icon p + title p + ul) into card wrappers
 * when the container has class "benefitCards".
 */
export function structureBenefitCards(root) {
  if (!root) return;

  const containers = [];
  if (root.classList.contains('benefitCards')) {
    containers.push(root);
  }
  root.querySelectorAll('.benefitCards').forEach((el) => {
    if (!containers.includes(el)) {
      containers.push(el);
    }
  });

  containers.forEach((container) => {
    if (container.querySelector('.benefitCards__card')) {
      return;
    }

    const uls = [...container.querySelectorAll(':scope > ul')].reverse();
    uls.forEach((ul) => {
      const titleP = ul.previousElementSibling;
      const iconP = titleP?.previousElementSibling;
      if (!titleP || titleP.tagName !== 'P' || !iconP || iconP.tagName !== 'P') {
        return;
      }

      const card = document.createElement('div');
      card.className = 'benefitCards__card';
      container.insertBefore(card, iconP);
      card.appendChild(iconP);
      card.appendChild(titleP);
      card.appendChild(ul);
    });
  });
}
